module.exports = __webpack_public_path__ + "btn_google.7ab131cff5.webp";